import {createGlobalStyle, css} from 'styled-components';

import {AddPrefix} from '@shared/lib/type_utils';

import {cssPx} from '@shared-web/lib/styled_utils';
import {FrontendTheme} from '@shared-web/theme/theme_model';

export const ThemeGlobalCss = css<AddPrefix<FrontendTheme['main'], '$'>>`
  font-family: ${p => p.$fontFamily};
  font-size: ${p => cssPx(p.$fontSize)};
  line-height: ${p => p.$lineHeight};
  background: ${p => p.$backgroundColor};
  color: ${p => p.$textColor};
`;

export const GlobalStyle = createGlobalStyle`${css<AddPrefix<FrontendTheme['main'], '$'>>`
  html,
  body,
  #root {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    box-sizing: border-box;
  }
  /* width: 100%;
    height: 100%; */
  /* } */
  html,
  body,
  #root {
    font-weight: 400;
    ${ThemeGlobalCss};
    margin: 0;
    padding: 0;
    overflow: visible;
  }

  [hidden] {
    display: none !important;
  }
`}`;
